<template>
    <div class="codics-aonaer-info-sys-breadcrumb">
        <div class="codics-aonaer-info-sys-breadcrumb-box">
            <span class="iconfont"
                style="font-size: 19px !important;position: relative;float: left;">&#xe622;&nbsp;&nbsp;&nbsp;</span>
            <div class="codics-aonaer-info-sys-breadcrumb-box-item" v-for="(item, index) in breadList" :key="index">
                <span class="codics-aonaer-info-sys-breadcrumb-box-item-title" @click="changePage(item)"
                    :style="{ 'color': index + 1 == breadList.length ? '#ea5b18 !important' : '#aaa', 'pointer-events': index + 1 == breadList.length ? 'none' : 'all' }">{{
                        item.title }}</span>
                <span style="padding: 0 0 0 10px;" v-show="index + 1 != breadList.length">-</span>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        breadList: {
            type: Array,
            default: [
                {
                    title: '网站首页',
                    url: '#'
                },
                {
                    title: '集团新闻',
                    url: '#'
                }
            ]
        }
    },
    data() {
        return {
            // breadList:[]
        }
    },
    methods: {
        changePage(item) {
            window.location = item.url;
        }
    },
    watch: {
        // $route: {
        //     handler(val, oldVal) {
        //         this.breadList = [];
        //         this.$route.matched.forEach((item, index) => {
        //             this.breadList.push({
        //                 title: item.name,
        //                 url: item.path
        //             });
        //         });
        //     },
        //     deep: true,
        //     immediate: true // 立即触发
        // }
    }
}
</script>

<style>
.codics-aonaer-info-sys-breadcrumb {
    height: 66px;
    width: 100%;
    position: relative;
    float: left;
    background: #f7f7f7;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-breadcrumb-box {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    color: #aaa;
    line-height: 66px;
}

.codics-aonaer-info-sys-breadcrumb-box-item {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 66px;
    text-align: center;
    box-sizing: border-box;
    padding: 0 10px 0 0;
    user-select: none;
    transition: .3s;
    user-select: none;
    -webkit-user-drag: none;
}

.codics-aonaer-info-sys-breadcrumb-box-item-title {
    transition: .3s;
    cursor: pointer;
}

.codics-aonaer-info-sys-breadcrumb-box-item .codics-aonaer-info-sys-breadcrumb-box-item-title:hover {
    color: #333 !important;
}
</style>